import {Component, OnInit} from '@angular/core';
import {Auth, ViewState} from 'src/common';

@Component({
  selector: 'app-supplier-auction-offer-list-ssy1280detail-details',
  templateUrl: 'supplier-auction-offer-list-ssy1280detail-details.component.html'
})
export class SupplierAuctionOfferListSsy1280detailDetailsComponent implements OnInit {

  viewState = ViewState;

  constructor() {
  }

  ngOnInit(): void {
    //Auth.checkAuthorization('');
  }

  // custom-start


  // custom-end


}
